module.exports = __webpack_public_path__ + "static/media/1_pl.b2386970.png";